import React from 'react';
import {connect} from "react-redux";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { checkIsAuthorized, authorizeWithActiveKey, authorizeWithKeychain } from "../helpers/authority";
import {
    login,
    fetchLogin,
    fetchTrails,
    fetchExecutedVotes,
    unvote,
    setVpThreshold,
    fetchHitlist,
    removeHitlist,
    addToHitlist,
    addToTrail,
    removeTrail,
    logout,
    setMinPayout,
    addToWhitelist,
    fetchWhitelist,
    removeWhitelist,
    setDvThreshold,
    setUpThreshold,
    saveSettings, setRevote, addToCounterDvBlacklist, fetchCounterDvBlacklist, removeCounterDvBlacklist
} from "../actions/actions";
import {toast} from "react-toastify";
// import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import "@devexpress/dx-react-grid";
import {Grid, PagingPanel, SearchPanel,Table,TableHeaderRow, Toolbar} from "@devexpress/dx-react-grid-bootstrap4";
import {IntegratedFiltering, IntegratedPaging, PagingState, SearchState, IntegratedSorting, SortingState} from "@devexpress/dx-react-grid";
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import {SyncLoader} from 'react-spinners';
import moment from 'moment';
import ProgressBar from 'react-bootstrap/ProgressBar'

const Joi = require('joi');

class Settings extends React.Component
{
    state = {
        trail_username: "",
        trail_ratio: 1,
        hitlist_percent: 50,
        hitlist_min_payout: 5,
        isAuthorized: true,
        activeKey: "",
        showActiveKey: false,
        authLoadingKeychain: false,
        authLoadingActive: false,
        authError: "",
        authSuccess: ""
    };

    loadUserData = () => {
        if (!this.props.logged_user || !this.props.logged_user.username) return;
        this.props.fetchTrails(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type);
        this.props.fetchWhitelist(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type);
        this.props.fetchHitlist(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type);
        this.props.fetchCounterDvBlacklist(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type);
        this.props.fetchExecutedVotes(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type);
    };

    async componentDidMount() {
        const { logged_user } = this.props;
        if (!logged_user || !logged_user.username) return;

        const authAccount = process.env.REACT_APP_AUTH_ACCOUNT || "steem-seven";
        const isAuthorized = await checkIsAuthorized(logged_user.username, authAccount);

        if (!isAuthorized) {
            this.setState({ isAuthorized: false });
            return;
        }

        this.setState({ isAuthorized: true });
        this.loadUserData();
    }

    handleAuthorizeKeychain = async () => {
        const { logged_user } = this.props;
        const authAccount = process.env.REACT_APP_AUTH_ACCOUNT || "steem-seven";
        this.setState({ authLoadingKeychain: true, authError: "", authSuccess: "" });

        try {
            const res = await authorizeWithKeychain(logged_user.username, authAccount);
            if (res.success) {
                toast.success(res.message);
                this.setState({ isAuthorized: true, authSuccess: res.message });
                this.loadUserData();
            } else {
                this.setState({ authError: res.message });
            }
        } catch (err) {
            this.setState({ authError: "Failed to authorize with Keychain." });
        } finally {
            this.setState({ authLoadingKeychain: false });
        }
    };

    handleAuthorizeActiveKey = async (e) => {
        if (e) e.preventDefault();
        const { logged_user } = this.props;
        const { activeKey } = this.state;
        const authAccount = process.env.REACT_APP_AUTH_ACCOUNT || "steem-seven";

        if (!activeKey || !activeKey.trim()) {
            this.setState({ authError: "Please enter your Private Active Key." });
            return;
        }

        this.setState({ authLoadingActive: true, authError: "", authSuccess: "" });

        try {
            const res = await authorizeWithActiveKey(logged_user.username, activeKey, authAccount);
            if (res.success) {
                toast.success(res.message);
                this.setState({ isAuthorized: true, activeKey: "", authSuccess: res.message });
                this.loadUserData();
            } else {
                this.setState({ authError: res.message });
            }
        } catch (err) {
            this.setState({ authError: "Failed to authorize with Active Key." });
        } finally {
            this.setState({ authLoadingActive: false });
        }
    };

    toggleShowActiveKey = () => {
        this.setState(prev => ({ showActiveKey: !prev.showActiveKey }));
    };

    trailed_schema = Joi.object().keys({
        username: Joi.string().min(3).max(16).required(),
        ratio: Joi.number().min(0.01).max(2.5),
    });

    whitelist_schema = Joi.object().keys({
        username: Joi.string().min(3).max(16).required(),
    });

    counter_dv_blacklist_schema = Joi.object().keys({
        username: Joi.string().min(3).max(16).required(),
    });

    hitlist_schema = Joi.object().keys({
        username: Joi.string().min(3).max(16).required(),
        percent: Joi.number().min(0.01).max(100),
        min_payout: Joi.number().min(0.01),
    });


    remove_trail = (trailed, type) =>
    {
            this.props.removeTrail(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, trailed, type);
    };

    remove_whitelist = (author) =>
    {
            this.props.removeWhitelist(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, author);
    };

    remove_counter_dv_blacklist = (author) =>
    {
            this.props.removeCounterDvBlacklist(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, author);
    };

    remove_hitlist = (author) =>
    {
            this.props.removeHitlist(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, author);
    };

    save_settings = (event) =>
    {
        event.preventDefault();

        this.props.saveSettings(this.props.logged_user);

    };

    save_min_payout = (event) =>
    {
            event.preventDefault();
            this.props.saveMinPayout(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type, this.props.logged_user.min_payout);
    };


    render_negative_trails = () =>
    {
        let rows = [];
        for (let i = 0; i < this.props.data.negative_trail.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.negative_trail[i].trailed}</td>
                <td>{this.props.data.negative_trail[i].ratio}</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_trail(this.props.data.negative_trail[i].trailed, -1)}>Delete</button></td>
            </tr>)
        }

        return rows

    };

    render_positive_trails = () =>
    {
        let rows = [];
        for (let i = 0; i < this.props.data.positive_trail.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.positive_trail[i].trailed}</td>
                <td>{this.props.data.positive_trail[i].ratio}</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_trail(this.props.data.positive_trail[i].trailed, 1)}>Delete</button></td>
            </tr>)
        }

        return rows
    };
    render_positive_upvote_trails = () =>
    {
        let rows = [];
        for (let i = 0; i < this.props.data.positive_upvote_trail.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.positive_upvote_trail[i].trailed}</td>
                <td>{this.props.data.positive_upvote_trail[i].ratio}</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_trail(this.props.data.positive_upvote_trail[i].trailed, 3)}>Delete</button></td>
            </tr>)
        }

        return rows
    };
    render_whitelist = () =>
    {
        let rows = [];
        for (let i = 0; i < this.props.data.whitelist.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.whitelist[i].trailed}</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_whitelist(this.props.data.whitelist[i].trailed)}>Delete</button></td>
            </tr>)
        }

        return rows
    };

    render_counter_downvote_blacklist = () =>
    {
        let rows = [];

        for (let i = 0; i < this.props.data.counter_dv_blacklist.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.counter_dv_blacklist[i].trailed}</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_counter_dv_blacklist(this.props.data.counter_dv_blacklist[i].trailed)}>Delete</button></td>
            </tr>)
        }

        return rows
    };

    render_hitlist = () =>
    {
        let rows = [];
        for (let i = 0; i < this.props.data.hitlist.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.hitlist[i].author}</td>
                <td>{this.props.data.hitlist[i].percent} %</td>
                <td>{this.props.data.hitlist[i].min_payout} $</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_hitlist(this.props.data.hitlist[i].author)}>Delete</button></td>
            </tr>)
        }

        return rows
    };

    render_counter_downvote_trail = () =>
    {
        let rows = [];
        for (let i = 0; i < this.props.data.counter_trail.length; i++) {
            rows.push(<tr>
                <td>{this.props.data.counter_trail[i].trailed}</td>
                <td>{this.props.data.counter_trail[i].ratio}</td>
                <td><button className={"btn btn-primary"} onClick={() => this.remove_trail(this.props.data.counter_trail[i].trailed, 2)}>Delete</button></td>
            </tr>)
        }

        return rows

    };

    add_trail = (event, type) =>
    {
        event.preventDefault();
        let test = Joi.validate({username : this.state.trail_username, ratio : this.state.trail_ratio}, this.trailed_schema);
        if (test.error === null)
            this.props.addToTrail(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, this.state.trail_username, this.state.trail_ratio, type);
        else
            toast.error(test.error.details[0].message);
    };

    add_whitelist = (event) =>
    {
        event.preventDefault();
        let test = Joi.validate({username : this.state.trail_username}, this.whitelist_schema);

        if (test.error === null)
            this.props.addToWhitelist(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, this.state.trail_username);
        else
            toast.error(test.error.details[0].message);
    };

    add_counter_dv_blacklist = (event) =>
    {
        event.preventDefault();
        let test = Joi.validate({username : this.state.trail_username}, this.counter_dv_blacklist_schema);

        if (test.error === null)
            this.props.addToCounterDvBlacklist(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, this.state.trail_username);
        else
            toast.error(test.error.details[0].message);
    };

    add_hitlist = (event) =>
    {
        event.preventDefault();
        let test = Joi.validate({username : this.state.trail_username, percent : this.state.hitlist_percent, min_payout : this.state.hitlist_min_payout}, this.hitlist_schema);

        if (test.error === null)
            this.props.addToHitlist(this.props.logged_user.username, this.props.logged_user.token,this.props.logged_user.type, this.state.trail_username,  this.state.hitlist_percent, this.state.hitlist_min_payout);
        else
            toast.error(test.error.details[0].message);
    };

    logout = () =>
    {
        this.props.logout(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type);
    };

    unvote = (username, permlink) =>
    {

        this.props.unvote(this.props.logged_user.username, this.props.logged_user.token, this.props.logged_user.type, username, permlink);
    };

    parse_vote_reason(reason, type)
    {
        try {
            reason = JSON.parse(reason);
        } catch (e) {
            return {trailed : "error", reason : "error"}
        }

        if (type < 3 && reason.trail !== null)
        {
            let trail = reason.trail;

            if (type === -1)
                return {trailed : trail.trailed, reason : "counter upvote"};
            else if (type === 1)
                return {trailed : trail.trailed, reason : "trailed downvote"};
            else if (type=== 2)
                return {trailed : trail.trailed, reason : "countered downvote"};
        } else if (type === 3)
                return {trailed : reason.trailed, reason : "trailed upvote"};

        return {trailed : "error", reason : "error"}
    }

    renderRows()
    {
        let votes = this.props.data.vote_history;
        let rows = [];

        for (let i = 0; i < votes.length; i++) {

            let button = "Unvote";

            if (votes[i].loading === true)
            {
                button = <div className='sweet-loading'>
                    <SyncLoader

                        sizeUnit={"px"}
                        size={4}
                        color={'#ffffff'}
                        loading={true}
                    />
                </div>
            }

            let vote_date =  moment.unix(votes[i].date).format("DD/MM/YY HH:mm");

            let reason = this.parse_vote_reason(votes[i].reason, votes[i].type);
            rows.push({
                author : votes[i].author,
                permlink : <a target={"_blank"} rel="noreferrer" href={"https://steemit.com/@"+votes[i].author+"/"+votes[i].permlink}> {votes[i].permlink}</a>,
                percentage : (reason.reason !== "hitlist" ? votes[i].percentage/100+ " %" : votes[i].percentage+ " %"),
                trailed : reason.trailed,
                reason : reason.reason,
                date : vote_date,
                unvote : <button className={"btn btn-primary"} style={{marginLeft : "5px"}} onClick={() => this.unvote(votes[i].author, votes[i].permlink)}>{button}</button> ,
                })
        }


        return rows;

    }

    compareDates = (a, b) => {
        return (moment(a, "DD/MM/YY HH:mm").unix()  < moment(b, "DD/MM/YY HH:mm").unix()) ? -1 : 1;
    };

    render_votes = () =>
    {

        const integratedSortingColumnExtensions = [
            { columnName: 'date', compare: this.compareDates },
        ];

        let columns = [
            { name: "date", title: "date (d/m/y)"},
            { name: "author", title: "author" },
            { name: "permlink", title: "permlink"},
            { name: "percentage", title: "percentage"},
            { name: "reason", title: "reason"},
            { name: "trailed", title: "voter"},
            { name: "unvote", title: " "},
        ];

        return (
        <Grid rows={this.renderRows()} columns={columns}>
            <SearchState />
            <IntegratedFiltering />
            <PagingState
                defaultCurrentPage={0}
                pageSize={15}
            />
            <SortingState
                defaultSorting={[{ columnName: 'date', direction: 'desc' }]}
            />
            <IntegratedSorting columnExtensions={integratedSortingColumnExtensions}/>
            <IntegratedPaging />

            <Table />
            <Toolbar />
            <SearchPanel />
            <TableHeaderRow showSortingControls />
            <PagingPanel />


        </Grid>
        )
    }
    render() {
        document.body.classList.remove('bg'); 
        const authAccount = process.env.REACT_APP_AUTH_ACCOUNT || "steem-seven";

        if (!this.state.isAuthorized) {
            return (
                <div>
                    <nav className="navbar navbar-expand-md navColor">
                        <a rel="noreferrer" className="navbar-brand" href="/">
                            <img
                                src="/logo.png"
                                height="30"
                                alt="logo"
                                style={{ paddingRight: 10 }}
                                className="d-inline-block align-top"
                            />
                            Steem Ways
                        </a>
                        <div className="collapse navbar-collapse" id="navbarsExampleDefault">
                            <ul className="navbar-nav mr-auto">
                                <a href={"/"} rel="noreferrer" onClick={this.logout}>Logout</a>
                            </ul>
                        </div>
                        <div className="justify-content-end loginColor">
                            Logged in as: @{this.props.logged_user?.username}
                        </div>
                    </nav>

                    <div className="container" style={{ maxWidth: "600px", marginTop: "40px", marginBottom: "50px" }}>
                        <div className="card shadow-sm border-0" style={{ borderRadius: "10px", overflow: "hidden", background: "#fff" }}>
                            <div className="card-header bg-white border-bottom text-center py-3">
                                <h4 style={{ color: "#001d46", margin: 0, fontWeight: "600" }}>
                                    Posting Authority Required
                                </h4>
                            </div>
                            <div className="card-body p-4">
                                <p style={{ color: "#555", fontSize: "14px", lineHeight: "1.6" }}>
                                    To enable automated curation trails and scheduled voting,{" "}
                                    <b>@{this.props.logged_user?.username}</b> must grant Posting Authority to{" "}
                                    <span className="badge badge-primary" style={{ backgroundColor: "#0200da", fontSize: "13px" }}>
                                        @{authAccount}
                                    </span>.
                                </p>
                                <div className="alert alert-info py-2 px-3 mb-4" style={{ fontSize: "12px" }}>
                                    <b>Security Note:</b> Posting Authority only allows automated voting/posting operations on your behalf. It <u>never</u> grants access to your wallet funds or transfers.
                                </div>

                                {this.state.authError && (
                                    <div className="alert alert-danger py-2" style={{ fontSize: "13px" }}>
                                        {this.state.authError}
                                    </div>
                                )}

                                {this.state.authSuccess && (
                                    <div className="alert alert-success py-2" style={{ fontSize: "13px" }}>
                                        {this.state.authSuccess}
                                    </div>
                                )}

                                {/* Option 1: Keychain */}
                                <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "15px", marginBottom: "20px" }}>
                                    <h6 style={{ color: "#001d46", fontWeight: "600", marginBottom: "6px" }}>
                                        Option 1: Authorize via Steem Keychain
                                    </h6>
                                    <p style={{ color: "#718096", fontSize: "12px", marginBottom: "12px" }}>
                                        If you have the Steem Keychain browser extension installed, authorize with one click.
                                    </p>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-block btn-sm"
                                        onClick={this.handleAuthorizeKeychain}
                                        disabled={this.state.authLoadingKeychain}
                                        style={{ fontWeight: "600" }}
                                    >
                                        {this.state.authLoadingKeychain ? "Authorizing via Keychain..." : "Authorize with Steem Keychain"}
                                    </button>
                                </div>

                                {/* Option 2: Active Key */}
                                <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "15px" }}>
                                    <h6 style={{ color: "#001d46", fontWeight: "600", marginBottom: "6px" }}>
                                        Option 2: Authorize with Private Active Key
                                    </h6>
                                    <p style={{ color: "#718096", fontSize: "12px", marginBottom: "12px" }}>
                                        Enter your Private Active Key (WIF) to broadcast the update transaction. Your Active Key is <b>never saved or stored in cookies</b>.
                                    </p>
                                    <form onSubmit={this.handleAuthorizeActiveKey}>
                                        <div className="form-group mb-3">
                                            <div className="input-group input-group-sm">
                                                <input
                                                    type={this.state.showActiveKey ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="5J... (Private Active Key)"
                                                    value={this.state.activeKey}
                                                    onChange={(e) => this.setState({ activeKey: e.target.value, authError: "" })}
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary"
                                                        onClick={this.toggleShowActiveKey}
                                                        style={{ fontSize: "11px" }}
                                                    >
                                                        {this.state.showActiveKey ? "Hide" : "Show"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block btn-sm"
                                            disabled={this.state.authLoadingActive}
                                            style={{ backgroundColor: "#0200da", borderColor: "#0200da", fontWeight: "600" }}
                                        >
                                            {this.state.authLoadingActive ? "Granting Authority..." : "Grant Posting Authority"}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div>
                <nav className="navbar navbar-expand-md  navColor">
                    <a rel="noreferrer" className="navbar-brand" href="/">
                        <img
                        src="/logo.png"
                        // width="40"
                        height="30"
                        alt='logo'
                        style={{paddingRight:10}}
                        className="d-inline-block align-top"
                        />Steem Ways
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarsExampleDefault">
                        <ul className="navbar-nav mr-auto">
                            <a href={"/"} rel="noreferrer" onClick={this.logout}>Logout</a>
                        </ul>
                    </div>
                    <div className="justify-content-end loginColor">
                    Logged in as: @{this.props.logged_user.username}
                    </div>
                </nav>

                    <main role="main" className="container">
                        <table style={{width: "100%",marginTop:"20px"}} className="table-bordered">
                                <tbody>
                                <tr>
                                    <th className="powerTable">Current voting power</th>
                                    <td className="powerTD"><ProgressBar animated now={this.props.logged_user.voting_power} label={this.props.logged_user.voting_power+"%"}/></td>
                                </tr>
                                <tr>
                                    <th className="powerTable">Current downvoting power</th>
                                    <td className="powerTD"><ProgressBar animated now={this.props.logged_user.downvoting_power} label={this.props.logged_user.downvoting_power+"%"} /></td>
                                </tr>
                                </tbody>
                            </table>
                        <br/>   
                    <h4>Global settings : </h4>

                    <form onSubmit={(e) => this.save_settings(e)}>
                        <p>Only use automatic downvote votes when power is above :
                            <input type={"number"} style={{width : "60px"}} max={100} min={0} value={this.props.logged_user.dv_threshold} onChange={(e) => this.props.setDvThreshold(e.target.value)}/> %
                        </p>
                        <p>Only use upvote trails when power is above :
                            <input type={"number"} style={{width : "60px"}} max={100} min={0} value={this.props.logged_user.up_threshold} onChange={(e) => this.props.setUpThreshold(e.target.value)}/> %
                        </p>
                        <p>If my downvoting power reaches 0, use my voting power to downvote when my power is above :
                            <input type={"number"} style={{width : "60px"}} max={100} min={0} value={this.props.logged_user.vp_threshold} onChange={(e) => this.props.setVpThreshold(e.target.value)}/> %
                            <br/><small>This setting also applies when upvoting to counter downvotes</small>
                        </p>

                    <p>Only downvote if the post has more than  :

                            <input type={"number"} style={{width : "60px"}} min={0} value={this.props.logged_user.min_payout} onChange={(e) => this.props.setMinPayout(e.target.value)}/>
                        $ of pending payouts.
                        <br/><small>Posts with 0$ payout won't be downvoted</small>
                    </p>
                    <p><input type={"checkbox"} checked={this.props.logged_user.revote === true} onChange={this.props.setRevote}/>   Re-vote if there is the opportunity to increase the upvote or downvote.
                        <br />This is useful to counter people that will do a small upvote to bait auto downvotes and then revote with a higher percentage.

                        <button style={{float : "right"}} onClick={(e) => this.save_settings(e)} className={"btn btn-primary"}>Save settings</button>
                    </p>
                    </form>
                    <hr/>
                    <Tabs defaultActiveKey="trail" id="modal-tab" transition={false} >

                        <Tab eventKey="trail" title="Trail" >
                            <h5> Follow upvote trail </h5>
                            <p> Allows you to trail the upvotes of a specific account and thus upvote any content they upvote at a given rate relative to the size of their upvote.</p>
                            <p>Example: If you choose to trail <b>@steem-seven</b> with rating 0.75, then if  <b>@steem-seven</b> gives a <b>100%</b> upvote to a post you will give the same post a <b>75%</b> upvote.</p>
                            <div className="alert alert-warning" role="alert">
                            <a href="trails/upvote">Show Upvoting trails</a> / <a href="trails/API">Get JSON data</a>
                            </div>
                            <form onSubmit={(e) => this.add_trail(e, 3)}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            <input type={"number"} min={0.01} max={2.5} step={0.01} style={{width : "60px"}} value={this.state.trail_ratio} onChange={(e) => this.setState({trail_ratio : e.target.value})}/>
                            <button className={"btn  btn-primary"} onClick={(e) => this.add_trail(e,3)}>Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Ratio</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_positive_upvote_trails()}

                                </tbody>
                            </table>
                            <hr/>
                            <h5> Follow downvote trail </h5>
                            <p> Allows you to trail the downvotes of a specific account and thus downvote any content they downvote at a given rate relative to the size of their downvote.</p>
                            <p>Example: If you choose to trail <b>@steem-seven</b> with rating 0.75, then if  <b>@steem-seven</b> gives a <b>50%</b> downvote to a post you will give the same post a <b>37.5%</b> downvote.</p>
                            <div className="alert alert-warning" role="alert">
                            <a href="trails/downvote">Show Downvoting trails</a> / <a href="trails/API">Get JSON data</a>
                            </div>
                            <form onSubmit={(e) => this.add_trail(e, 1)}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            <input type={"number"} min={0.01} max={2.5} step={0.01} style={{width : "60px"}} value={this.state.trail_ratio} onChange={(e) => this.setState({trail_ratio : e.target.value})}/>
                            <button className={"btn  btn-primary"} onClick={(e) => this.add_trail(e,1)}>Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Ratio</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_positive_trails()}

                                </tbody>
                            </table>
                            
                            
                        </Tab> 
                        <Tab eventKey="counter_upvotes" title="Counter upvotes " >
                            <h5> Counter upvotes </h5>
                            <p> Used to counteract upvotes from specified accounts, meaning that you will downvote anything that they choose to upvote at a given rate relative to their upvote. </p>
                            <p>Example: If you choose to counter upvote <b>@baduser</b> with rating 1.2, then if <b>@baduser</b> gives a 50% upvote to something, you will add a <b>60%</b> downvote to the same post or comment, while a rating of 0.5 would make you downvote <b>25%</b>, etc.</p>
                            <form onSubmit={(e) => this.add_trail(e, -1)}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            <input type={"number"} min={0} max={2.5} step={0.1} style={{width : "60px"}} value={this.state.trail_ratio} onChange={(e) => this.setState({trail_ratio : e.target.value})}/>
                            <button className={"btn btn-primary"} onClick={(e) => this.add_trail(e, -1)} >Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Ratio</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_negative_trails()}

                                </tbody>
                            </table>
                        </Tab>
                        <Tab eventKey="counter_downvotes" title="Counter downvotes " >
                            <h5> Counter downvotes </h5>
                            <p> Used to counteract downvotes from specified accounts, meaning that you will upvote anything that they choose to downvote at a given rate relative to their downvote. </p>
                            <p>Example: If you choose to counter downvote <b>@baduser</b> with rating 1.2, then if <b>@baduser</b> gives a 50% downvote on something, you will do a <b>60%</b> upvote to the same post or comment, while a rating of 0.5 would make you upvote at <b>25%</b>, etc.</p>
                            <form onSubmit={(e) => this.add_trail(e, 2)}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            <input type={"number"} min={0} max={2.5} step={0.1} style={{width : "60px"}} value={this.state.trail_ratio} onChange={(e) => this.setState({trail_ratio : e.target.value})}/>
                            <button className={"btn btn-primary"} onClick={(e) => this.add_trail(e, 2)} >Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Ratio</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_counter_downvote_trail()}

                                </tbody>
                            </table>
                        </Tab>
                        <Tab eventKey="counter_dv_blacklist" title="Counter downvotes blacklist" >
                            <h5> Counter downvotes blacklist </h5>
                            <p>Counter downvotes author blacklist, you won't counter the downvotes if the reciever of the vote is in this list. Separate each user by a comma <br/></p>
                            <form onSubmit={this.add_counter_dv_blacklist}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            <button className={"btn btn-primary"} onClick={this.add_counter_dv_blacklist} >Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_counter_downvote_blacklist()}

                                </tbody>
                            </table>
                        </Tab>
                        <Tab eventKey="whitelist" title="Whitelist" >
                            <h5> Whitelist </h5>
                            <p>You won't downvote the users in this list</p>
                            <form onSubmit={this.add_whitelist}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            <button className={"btn btn-primary"} onClick={this.add_whitelist} >Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_whitelist()}

                                </tbody>
                            </table>
                        </Tab>
                        <Tab eventKey="hitlist" title="Hit list" >
                            <h5> Hist list </h5>
                            <p>Downvote user using x% whenever his post or comment reaches more than y$ (the number of dollar is the one in the global settings) </p>
                            <p>For instance you can configure the tool to downvote user @milkinguser whenever he makes more than 5$ on a post or comment with a 30% downvote</p>
                            Downvote
                            <form onSubmit={() => this.add_hitlist}>
                            <input type={"text"} placeholder={"username"} value={this.state.trail_username} onChange={(e) => this.setState({trail_username : e.target.value})}/>
                            With a
                            <input type={"number"} style={{width : "60px"}}  min={0.1} max={100} value={this.state.hitlist_percent} onChange={(e) => this.setState({hitlist_percent : e.target.value})}/>
                            % downvote if his post has a payout superior to
                            <input type={"number"} style={{width : "60px"}}   value={this.state.hitlist_min_payout} onChange={(e) => this.setState({hitlist_min_payout : e.target.value})}/> $

                            <button className={"btn btn-primary"} style={{marginLeft : "5px"}} onClick={this.add_hitlist} >Add</button>
                            </form>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Username</th>
                                    <th scope="col">downvote percent</th>
                                    <th scope="col">Minimum payout</th>
                                    <th scope="col">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.render_hitlist()}
                                </tbody>
                            </table>
                        </Tab>
                        <Tab eventKey="vote_history" title="Vote history" >
                            <h5>Vote history </h5>
                            <p>Here's the history of all the votes you made though this tool</p>
                            {this.render_votes()}
                        </Tab>
                    </Tabs>
                </main>
            </div>
        )

    }

}


const mapStateToProps = (state) => {
    return {
        logged_user : state.user,
        data : state.data,
    };
};

export default connect(mapStateToProps, {login,unvote,fetchCounterDvBlacklist,removeCounterDvBlacklist, logout, fetchLogin,fetchWhitelist,addToCounterDvBlacklist,fetchExecutedVotes,saveSettings,setRevote, fetchTrails, addToTrail, addToHitlist, removeHitlist, removeTrail, setDvThreshold,setUpThreshold, setVpThreshold, setMinPayout, addToWhitelist, removeWhitelist, fetchHitlist})(Settings);